import {required, image, imageSize5} from '../../../../../_utils/validators';

const imageValidator = (file) => {
  let error = required(file.name);
  if (!error) error = image(file.name);
  if (!error) error = imageSize5(Math.ceil(file.size/1024/1024));
  return error ? error : undefined;
};

export default imageValidator;